module.exports = __webpack_public_path__ + "media/1.baee6c91.wav";